export function containsChinese(text: string): boolean {
  const chineseRegex = /[\u4e00-\u9fff]/;
  return chineseRegex.test(text);
}

export function containsNonEuropeanChars(text: string): boolean {
  const nonLatinRegex = /[^\u0000-\u007F\u00C0-\u024F]/u;
  return nonLatinRegex.test(text);
}

export function containsAttackChars(text: string): boolean {
  // Regex to match characters commonly used in attacks
  const attackCharsRegex = /[<>'";`\\]|--|\/\*|\*\//;
  return attackCharsRegex.test(text);
}
